export enum UserRoleEnum {
  ADMIN,
  MANAGER,
  AUDITOR,
  GRP_CEI_SUPORTE,
  MASTER
}
